<template>
  <div>
    <pcHeaders :value="queryParams.codeNo" @updateParentValue="handleUpdate"></pcHeaders>

    <div class="banner">
      <div class="bannerBox">
        <div class="section">
          <div style="display: flex; justify-content: space-between">
            <div class="hen" style="margin-bottom: 20px; align-items: center">
              <!-- <div style="margin-right: 0; font-size: 14px; height: 25px; line-height: 25px; width: 80px">课程搜索：</div> -->
              <div class="searBoxs">
                <input type="text" class="sear" v-model="queryParams.courseName" placeholder="搜索你想要的课程关键词" />
                <div class="ss" @click="handlSear">搜索</div>

                <!-- <div class="seletClass">
                <div style="display: flex" @click="showSearFlag = !showSearFlag">
                  <div>{{ searShowText }}</div>
                  <div>
                    <img
                      style="width: 10px; height: 10px; margin-left: 4px; margin-top: 4px"
                      src="../../assets/images/zk_icon.png"
                      alt=""
                      v-if="showSearFlag"
                    />
                    <img
                      style="width: 10px; height: 10px; margin-left: 4px; margin-top: 4px"
                      src="../../assets/images/sq_icon.png"
                      alt=""
                      v-else
                    />
                  </div>
                  <div class="su"></div>
                </div>

                <div class="showBox" v-if="showSearFlag">
                  <div @click="handSelet('1')">班级</div>
                  <div @click="handSelet('2')">分类</div>
                </div>
              </div> -->
              </div>
            </div>
            <div class="myCourse" @click="handleJiti">
              <img style="margin-right: 5px" src="../../assets/images/zcimg/cicon.png" alt="" />我的课程名单（{{ myCourseNum }}）
            </div>
          </div>
          <div class="group_1" v-if="categoryList.length > 0">
            <div class="firstBox" :class="{ active23: tab1 === 0 }" @click="categoryHandel(categoryList[0], 0)">
              {{ categoryList[0] ? categoryList[0].CODE_NAME : '' }}
              <div class="text_category">公需必修 免费学习</div>

              <div class="icon"><img src="../../assets/images/Mask group@2x (2).png" alt="" /></div>
            </div>
            <div class="secondBox" :class="{ active24: tab1 === 1 }" @click="categoryHandel(categoryList[1], 1)">
              {{ categoryList[1].CODE_NAME ? categoryList[1].CODE_NAME : '' }}
              <div class="text_category">精研专业 赋能提升</div>

              <div class="icon"><img src="../../assets/images/icon_2 (2).png" alt="" /></div>
            </div>
            <div class="thirdBox" :class="{ active25: tab1 === 2 }" @click="categoryHandel(categoryList[2], 2)">
              {{ categoryList[2].CODE_NAME ? categoryList[2].CODE_NAME : '' }}
              <div class="text_category">转型赋能 职业新途</div>

              <div class="icon"><img src="../../assets/images/icon_3.png" alt="" /></div>
            </div>
          </div>
          <div class="group_2">
            <div class="codetitle">
              <span style="color: #ff8833">{{ currentCategoryName }}</span
              >系列
            </div>
            <div style="display: flex; flex-wrap: wrap; width: 1300px">
              <div
                class="codeText"
                :class="{ codeTextActive: tab2 === index }"
                v-for="(item, index) in industryList"
                :title="item.CODE_NAME"
                :key="item.ID"
                @click="industryHandel(item, index)"
              >
                {{ item.CODE_NAME }}
              </div>
            </div>
          </div>
          <div class="group_3" v-if="specialityList.length > 0">
            <div class="codetitle">
              <span style="color: #ff8833">{{ currentCategoryName1 }}</span
              >专业
            </div>
            <div style="display: flex; flex-wrap: wrap; width: 1300px">
              <div
                class="codeText"
                :class="{ codeTextActive: tab3 === index }"
                v-for="(item, index) in specialityList"
                :title="item.CODE_NAME"
                :key="item.ID"
                @click="specialityHandel(item, index)"
              >
                {{ item.CODE_NAME }}
              </div>
            </div>
          </div>
          <div class="group_4" v-if="seriesList.length > 0">
            <div class="codetitle">
              <span style="color: #ff8833">{{ currentCategoryName2 }}</span
              >类别
            </div>
            <div style="display: flex; flex-wrap: wrap; width: 1300px">
              <div
                class="codeText"
                :class="{ codeTextActive: tab4 === index }"
                v-for="(item, index) in seriesList"
                :title="item.CODE_NAME"
                :key="item.ID"
                @click="seriesHandel(item, index)"
              >
                {{ item.CODE_NAME }}
              </div>
            </div>
          </div>
          <!-- <div class="hen">
            <div style="margin-right: 0; font-size: 14px; height: 25px; line-height: 25px; width: 80px">选择分类：</div>
            <div style="display: flex; flex-wrap: wrap; width: 1300px">
              <div
                :class="tab1 == index ? 'selet1 seletActive1' : 'selet1'"
                v-for="(item, index) in categoryList"
                :key="item.ID"
                :title="item.CODE_NAME"
                @click="categoryHandel(item, index)"
              >
                {{ item.CODE_NAME }}
              </div>
            </div>
          </div>

          <div class="hen" style="padding-top: 20px">
            <div style="margin-right: 0; font-size: 14px; height: 25px; line-height: 25px; width: 80px">选择系列：</div>
            <div style="display: flex; flex-wrap: wrap; width: 1300px">
              <div
                :class="tab2 == index ? 'selet seletActive' : 'selet'"
                v-for="(item, index) in industryList"
                :title="item.CODE_NAME"
                :key="item.ID"
                @click="industryHandel(item, index)"
              >
                {{ item.CODE_NAME }}
              </div>
            </div>
          </div>

          <div class="hen" style="padding-top: 20px">
            <div style="margin-right: 0; font-size: 14px; height: 25px; line-height: 25px; width: 80px">选择专业：</div>

            <div style="display: flex; flex-wrap: wrap; width: 1300px">
              <div
                :class="tab3 == index ? 'selet seletActive' : 'selet'"
                v-for="(item, index) in specialityList"
                :title="item.CODE_NAME"
                :key="item.ID"
                @click="specialityHandel(item, index)"
              >
                {{ item.CODE_NAME }}
              </div>
            </div>
          </div>

          <div class="hen" style="padding-top: 20px" v-if="seriesList.length > 0">
            <div style="margin-right: 0; font-size: 14px; height: 25px; line-height: 25px; width: 80px">选择类别：</div>

            <div style="display: flex; flex-wrap: wrap; width: 1300px">
              <div
                :class="tab4 == index ? 'selet seletActive' : 'selet'"
                v-for="(item, index) in seriesList"
                :title="item.CODE_NAME"
                :key="item.ID"
                @click="seriesHandel(item, index)"
              >
                {{ item.CODE_NAME }}
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="banner" style="background: #f6f9fc; min-height: 500px">
      <div class="listBox" v-if="classList[0] !== ''">
        <div class="fliesMcour" @click="handleJiti">
          <div>
            <div class="f1"><img src="../../assets/images/zcimg/cicon.png" alt="" /></div>
            <div class="f1">课程名单</div>
            <div class="f1">（{{ myCourseNum }}）</div>
          </div>
        </div>
        <div class="forBox" v-if="classList.length !== 0">
          <div v-for="item in classList" :key="item.ID" class="couserBox">
            <div class="cimg" @click="courseDetail(item)">
              <img :src="item.C_IMAGE" alt="" v-if="item.C_IMAGE !== null" />
              <img src="../../assets/images/classImg_no.png" v-else alt="" style="position: absolute; top: 0; left: 0" />

              <div
                v-if="item.C_IMAGE == null"
                style="text-align: center; color: #fff; position: relative; z-index: 2; font-size: 16px; padding: 0 10px; width: 220px"
              >
                {{ item.C_NAME }}
              </div>
            </div>
            <div class="ctext">
              <div class="c1" @click="courseDetail(item)">{{ item.C_NAME }}</div>
              <div class="c2">
                <div class="c3" @click="courseDetail(item)">{{ item.C_CREDITHOUR }}学时</div>
                <div class="c4" v-if="item.isBuy == '01'" @click="addUserCourse(item.ID)">加入课程名单</div>
                <div class="c4 c5" v-else>已加入课程名单</div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="forBox"
          style="display: flex; justify-content: center; align-items: center; font-size: 18px"
          v-if="classList.length == 0"
        >
          暂无数据~
        </div>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="getClassList"
        />
      </div>
    </div>
    <!-- 我的课程 -->
    <el-dialog title="我的课程名单" :visible.sync="dialogVisible" width="840px" :before-close="handleClose" center="">
      <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" header-row-class-name="my-table-header-row">
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column label="序号" width="80" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="课程名称" align="center">
          <template slot-scope="scope">
            {{ scope.row.courseName }}
          </template>
        </el-table-column>
        <el-table-column label="课程类型" width="120" align="center">
          <template slot-scope="scope">
            {{ scope.row.courseCodeName }}
          </template>
        </el-table-column>
        <el-table-column label="课程学时" width="120" align="center">
          <template slot-scope="scope">
            {{ scope.row.courseCredit }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="removeCourse(scope.row.id)" plain>移除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <pagination
          background
          v-show="total1 > 0"
          :total="total1"
          :page.sync="courseParams.pageNum"
          :limit.sync="courseParams.pageSize"
          @pagination="getTableData"
        />
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="handleBack">返回课程</el-button>
        <el-button type="danger" @click="handleRemove" :disabled="!multipleSelection.length">移除</el-button>
        <el-button type="primary" :disabled="!multipleSelection.length" @click="handleExport">导出到本地</el-button>
      </div>
    </el-dialog>
    <pcBottom></pcBottom>
    <flotRight />
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import pcHeaders from '../component/head.vue';
import pcBottom from '../component/bottom.vue';
import { saveAs } from 'file-saver';
import {
  exportUserCourseCw,
  removeUserCourse,
  getUserCourseList,
  getProjectCodeList,
  getClassList,
  addUserCourse,
  getUserCourseCount
} from '@/api/list.js';
import { doShoppingCartZG } from '@/api/car.js';
import flotRight from '@/views/component/flotRight.vue';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    pcHeaders,
    pcBottom,
    flotRight
  },
  data() {
    // 这里存放数据
    return {
      dialogVisible: false,
      tableData: [],
      total1: 0,
      multipleSelection: [],
      categoryList: [], //系列
      industryList: [], //行业
      specialityList: [], //专业
      seriesList: [], //类别
      tab1: 0, //选中
      tab2: 0,
      tab3: '',
      tab4: '',
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        className: ''
      },
      total: 0,
      classList: [''],
      codeNo: null, //跳转过来的code
      fCodeNo: null,
      defaultImageUrl: require('../../assets/images/noimg.png'),
      carFlag: true, //购物防止重复点击
      searText: '',
      showSearFlag: false,
      searType: '1', //1班级
      searShowText: '班级',
      codeNo1: '',
      activeGroupIndex: 0,
      currentCategoryName: '',
      currentCategoryName1: '',
      currentCategoryName2: '',
      myCourseNum: 0,
      myCourseList: [],
      courseParams: {
        pageNum: 1,
        pageSize: 10
      }
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
    '$route.query.codeNo': function (newVal) {
      console.log('URL参数已经更新', newVal);
      this.codeNo = newVal;
      this.getList();
    },
    '$route.query.fCodeNo': function (newVal) {
      console.log('URL参数已经更新', newVal);
      this.fCodeNo = newVal;
    },
    '$route.query.className': function (newVal) {
      console.log('URL参数已经更新', newVal);
      this.queryParams.className = newVal;
      if (this.queryParams.className !== '') {
        this.tab1 = null;
        this.tab2 = null;
        this.tab3 = null;
        this.queryParams.codeNo = '';
      } else {
        this.tab1 = 0;
        this.tab2 = 0;
      }
      this.getClassList();
    }
  },
  // 方法集合
  methods: {
    //获取当前用户选课数量
    getUserCourseCount() {
      getUserCourseCount().then(res => {
        console.log(res.data.data);
        this.myCourseNum = res.data.data;
      });
    },
    //加入课程名单
    addUserCourse(id) {
      addUserCourse({ courseId: id }).then(res => {
        console.log(res);
        if (res.data.code == '200') {
          this.$message.success('添加成功');
          this.getUserCourseCount();
          this.getClassList();
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
    },
    getTableData() {
      //
      getUserCourseList(this.courseParams).then(res => {
        this.tableData = res.data.rows;
        this.total1 = res.data.total;
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableData();
    },
    handleBack() {
      this.dialogVisible = false;
      // 可在这里添加返回逻辑
    },
    //删除单个
    removeCourse(id) {
      removeUserCourse({ ids: id }).then(res => {
        console.log(res.data.code);
        if (res.data.code == '200') {
          // 执行移除逻辑
          this.$message.success('移除成功');
          this.getTableData();
          this.getClassList();
        }
      });
    },
    handleRemove() {
      let ids = [];
      this.multipleSelection.forEach(v => {
        ids.push(v.id);
      });
      this.$confirm('确定要移除选中的课程吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          removeUserCourse({ ids: ids.toString() }).then(res => {
            console.log(res.data.code);
            if (res.data.code == '200') {
              // 执行移除逻辑
              this.$message.success('移除成功');
              this.getTableData();
              this.getClassList();
            }
          });
        })
        .catch(() => {});
    },
    handleExport() {
      if (this.multipleSelection.length == 0) {
        this.$message.error('请选择需要导出的课程！');
        return false;
      }
      let ids = [];
      this.multipleSelection.forEach(v => {
        ids.push(v.courseId);
      });

      // 改造核心：调用接口时添加响应类型配置，处理二进制流下载
      exportUserCourseCw({ids: ids.toString()})
        .then(async res => {
          // 后端返回的已经是 blob 了，直接用
          const blob = res;
          // 可选：如果后端返回了文件名，从响应头取，更规范
          const fileName = `export_${new Date().getTime()}.xlsx`;
          saveAs(blob, fileName);

          this.$message.success('导出成功');
        })
        .catch(error => {
          // 异常处理
          console.error('导出失败：', error);
          this.$message.error('导出失败，请稍后重试');
        });
    },
    //选择搜索种类
    handSelet(id) {
      this.searType = id;
      if (id == '1') {
        this.searShowText = '班级';
      } else {
        this.searShowText = '分类';
      }
      this.showSearFlag = false;
    },
    //重置搜索
    clerSear() {
      this.queryParams.className = '';
      this.queryParams.codeNo = '0702';
      this.queryParams.pageNum = 1;
      this.queryParams.pageSize = 10;
      this.tab1 = 0;
      this.getClassList();
    },
    //搜索课程
    handlSear() {
      // this.tab1 = null;
      this.tab2 = null;
      this.tab3 = null;
      // this.queryParams.codeNo = '';
      this.queryParams.pageNum = 1;
      this.queryParams.pageSize = 10;
      this.queryParams.choose = this.searType;
      if (this.codeNo1 == '') {
        this.queryParams.codeNo = this.categoryList[0].CODE_NO;
      } else {
        this.queryParams.codeNo = this.codeNo1;
      }

      this.getClassList();
    },
    handleUpdate(newValue) {
      console.log('newValue', newValue);
      this.queryParams.codeNo = newValue.localValue; // 处理子组件传递过来的新值
      this.queryParams.className = newValue.className; // 处理子组件传递过来的新值
      this.queryParams.pageNum = 1; // 处理子组件传递过来的新值
      this.queryParams.pageSize = 10; // 处理子组件传递过来的新值
      this.tab1 = null;
      this.tab2 = null;
      this.tab3 = null;
      this.getClassList();
    },
    //公需课
    toGx() {
      this.$router.push('/gx');
    },
    //试听
    tableHandel(row) {
      this.$router.push({
        path: '/classDetail2',
        query: {
          classId: row.ID
        }
      });
    },
    purchase(item) {
      if (item.ISCLASSAPPLY == '02') {
        if (this.carFlag) {
          this.carFlag = false;
          //整体报名直接加入购物车
          doShoppingCartZG({ classId: item.ID }).then(res => {
            if (res.data.data.code == '1') {
              this.$message({
                message: '添加购物车成功！',
                type: 'success'
              });
              this.$router.push('/car');
              this.carFlag = true;
            } else {
              this.$message({
                message: res.data.data.msg,
                type: 'warning'
              });
              this.carFlag = true;
            }
          });
        }
        return false;
      }
      //非整体报名
      this.$router.push({
        path: '/purchase',
        query: {
          id: item.ID
        }
      });
    },
    // 类别点击
    seriesHandel(item, index) {
      this.tab4 = index;
      this.queryParams.pageNum = 1;
      this.queryParams.codeNo = item.CODE_NO;
      this.getClassList();
    },
    //系列点击
    categoryHandel(item, index) {
      console.log(item, '23');

      this.tab1 = index;
      if (item.CODE_NAME) {
        this.currentCategoryName = item.CODE_NAME;
      }
      this.queryParams.codeNo = item.CODE_NO;
      this.codeNo1 = item.CODE_NO;
      this.queryParams.pageNum = 1; //点击行业重置页数
      this.queryParams.className = ''; //清空输入框
      this.getClassList();
      this.tab2 = null;
      this.tab3 = null;
      this.industryList = item.children;
      this.specialityList = [];
      this.seriesList = [];
    },
    //行业点击
    industryHandel(item, index) {
      console.log(item, '34');
      this.currentCategoryName1 = item.CODE_NAME;
      this.tab2 = index;
      this.tab3 = null;
      this.queryParams.codeNo = item.CODE_NO;
      this.queryParams.pageNum = 1; //点击行业重置页数
      this.getClassList();
      this.specialityList = [];
      this.seriesList = [];
    },
    //专业点击
    specialityHandel(item, index) {
      this.tab3 = index;
      this.tab4 = null;
      this.currentCategoryName2 = item.CODE_NAME;

      this.queryParams.pageNum = 1; //点击行业重置页数
      this.queryParams.codeNo = item.CODE_NO;
      this.getClassList();
      // this.seriesList = item.children;
      this.seriesList = [];
    },
    //获取课程
    handleJiti() {
      this.getTableData();
      this.dialogVisible = true;
    },
    //获取班级列表
    getClassList() {
      getClassList(this.queryParams).then(res => {
        console.log(res);

        this.classList = res.data.data.ph.rows;
        this.total = res.data.data.ph.total;
        if (Array.isArray(res.data.data.children)) {
          if (res.data.data.children.length !== 0) {
            this.industryList = res.data.data.children;
          }
        }
        this.searText = this.queryParams.className;
      });
    },
    //班级详情
    courseDetail(item) {
      this.$router.push({
        path: '/classDetail',
        query: {
          courseId: item.ID
        }
      });
    },
    handleError(event) {
      event.target.src = this.defaultImageUrl;
    },
    getList() {
      getProjectCodeList({ codeNo: '' }).then(res => {
        this.categoryList = res.data.data;
        if (this.categoryList.length > 0) {
          this.activeGroupIndex = 0;
          this.currentCategoryName = this.categoryList[1].CODE_NAME;
          // 初始化第一个分类下的行业列表
          if (this.categoryList[0].children) {
            this.industryList = this.categoryList[0].children;
          }
        }
        if (this.codeNo == null && this.fCodeNo !== null) {
          this.categoryList.forEach((v, idx) => {
            if (v.CODE_NO == this.fCodeNo) {
              this.$nextTick(() => {
                this.tab1 = idx;
              });
              data.children = v.children;
            }
          });

          this.categoryHandel(this.categoryList[0], 0);
          return false;
        }

        if (this.codeNo !== null && this.fCodeNo !== null) {
          this.queryParams.codeNo = this.codeNo;
          this.categoryList.forEach((v, idx) => {
            if (v.CODE_NO == this.fCodeNo) {
              this.$nextTick(() => {
                this.tab1 = idx;
              });
              this.industryList = v.children;
              v.children.forEach((x, index) => {
                if (x.CODE_NO == this.codeNo) {
                  this.$nextTick(() => {
                    this.tab2 = index;
                  });
                }
              });
            }
          });
          let data = {
            CODE_NO: this.codeNo
          };
          this.industryHandel(data, 0);
        } else {
          this.queryParams.codeNo = this.categoryList[0].children[0].CODE_NO;
          this.industryList = this.categoryList[0].children;
          this.industryHandel(this.categoryList[0].children[0], 0);
        }
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getUserCourseCount();
    if (this.$route.query.codeNo || this.$route.query.fCodeNo) {
      this.codeNo = this.$route.query.codeNo;
      this.fCodeNo = this.$route.query.fCodeNo;
    }
    if (this.$route.query.className && this.$route.query.className !== '') {
      this.queryParams.className = this.$route.query.className;
      this.getClassList();
      getProjectCodeList().then(res => {
        this.categoryList = res.data.data;
        this.tab1 = null;
        this.tab2 = null;
        this.tab3 = null;
        this.industryList = this.categoryList[0].children;
      });
    } else {
      this.queryParams.className = '';
      this.getList();
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
::v-deep .el-checkbox__inner {
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  border-color: #ff9120 !important;
  background-color: #ff9120 !important;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #ff9120 !important;
}
::v-deep .el-dialog__title {
  color: #333 !important;
  font-weight: bold;
}
::v-deep .my-table-header-row {
  color: #333 !important;
  background: #f4f4f4 !important;
  font-weight: 400 !important;
}
.myCourse {
  cursor: pointer;
  height: 46px;
  background: linear-gradient(87deg, #ffc64c 0%, #ff790c 100%);
  box-shadow: 0px 2px 10px 0px rgba(201, 117, 11, 0.4);
  border-radius: 8px 8px 8px 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #fff;
  padding: 0 9px;
}
.banner {
  background-color: #f6f9fc;
  font-family: Regular;
  display: flex;
  justify-content: center;
  .bannerBox {
    margin-top: 16px;
    padding: 24px 20px;
    width: 1400px;
    height: auto;
    background: #ffffff;
    box-shadow: 0px 2px 15px 0px rgba(138, 138, 138, 0.08), inset 0px 20px 50px 0px #f0f3f9;
    border-radius: 10px 10px 10px 10px;
    border: 1px solid #ffffff;
  }
  .listBox {
    position: relative;
    width: 1400px;
    padding-top: 40px;
    .fliesMcour {
      position: fixed;
      top: 561px;
      right: 153px;
      cursor: pointer;
      width: 80px;
      height: 90px;
      background: linear-gradient(87deg, #ffc64c 0%, #ff790c 100%);
      box-shadow: 0px 2px 10px 0px rgba(201, 117, 11, 0.4);
      border-radius: 8px 8px 8px 8px;
      padding: 10px 0;
      display: flex;
      justify-content: center;
      .f1 {
        text-align: center;
        font-size: 16px;
        color: #ffffff;
      }
    }
    .forBox {
      width: 1400px;
      min-height: 400px;
      display: flex;
      flex-wrap: wrap;
      .couserBox {
        width: 220px;
        height: 279px;
        background: #ffffff;
        border-radius: 4px 4px 4px 4px;
        margin-right: 16px;
        margin-bottom: 24px;
        cursor: pointer;
        .cimg {
          width: 220px;
          height: 176px;
          position: relative;
          display: flex;
          align-items: center;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .ctext {
          padding: 10px 12px 0 12px;
          .c1 {
            font-size: 16px;
            color: #000000;
            width: 195px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .c2 {
            margin-top: 17px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .c3 {
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #999999;
            }
            .c4 {
              text-align: center;
              line-height: 32px;
              color: #ffc64c;
              cursor: pointer;
              width: 112px;
              height: 32px;
              border-radius: 4px 4px 4px 4px;
              border: 1px solid;
              border-image: linear-gradient(87deg, rgba(255, 198, 76, 1), rgba(255, 121, 12, 1)) 1 1;
            }
            .c5 {
              background: #eaeaea !important;
              color: #8b8b8b !important;
              border: 0 !important;
            }
          }
        }
      }
      .couserBox:nth-child(6n) {
        margin-right: 0 !important;
      }
    }
  }
  .section {
    // width: 1400px;
    // padding: 20px 0 30px 0;
    .hen {
      display: flex;
      .searBoxs {
        width: 330px;
        height: 46px;

        // width: 380px;
        // height: 46px;
        position: relative;
        .seletClass {
          position: absolute;
          top: 0;
          height: 46px;
          left: 20px;
          color: #217cbe;
          display: flex;
          align-items: center;
          cursor: pointer;
          font-size: 14px;
          .showBox {
            position: absolute;
            bottom: -55px;
            left: -15px;
            width: 59px;
            height: 64px;
            background: #ecf1fe;
            box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
            border-radius: 6px 6px 6px 6px;
            div {
              width: 100%;
              height: 32px;
              text-align: center;
              line-height: 32px;
              color: #333;
            }
          }
          .su {
            width: 1px;
            height: 16px;
            background: #d6d6d6;
            margin-left: 13px;
          }
        }
        .sear {
          width: 330px;
          height: 46px;
          background: rgba(64, 118, 246, 0.1);
          background: rgba(64, 118, 246, 0.1);
          border-radius: 9px 9px 9px 9px;
          border: 1px solid rgba(64, 118, 246, 0.1);
          color: #8a8a8a;
          padding-left: 20px;
          // padding-left: 90px;
          // padding-right: 90px;
          border: 0 !important;
        }
        .ss {
          text-align: center;
          line-height: 36px;
          width: 76px;
          height: 36px;
          background: #217cbe;
          border-radius: 8px 8px 8px 8px;
          border: 1px solid #217cbe;
          color: #fff;
          position: absolute;
          right: 5px;
          top: 5px;
          cursor: pointer;
          font-size: 14px;
        }
      }
      .selet1 {
        padding: 0 16px;
        font-size: 14px;
        margin-right: 7px;
        cursor: pointer;
        height: 25px;
        line-height: 25px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        border-radius: 12px;
        color: #666;
      }
      .selet1:hover {
        background: rgba(64, 118, 246, 0.1);
        color: #217cbe;
      }
      .seletActive1 {
        background: rgba(64, 118, 246, 0.1);
        color: #217cbe;
      }
      .selet {
        width: 160px;
        padding: 0 16px;
        margin-top: 2px;
        font-size: 14px;
        margin-right: 25px;
        cursor: pointer;
        height: 25px;
        line-height: 25px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        border-radius: 12px;
        color: #666;
      }
      .selet:hover {
        background: rgba(64, 118, 246, 0.1);
        color: #217cbe;
      }
      .seletActive {
        background: rgba(64, 118, 246, 0.1);
        color: #217cbe;
      }
    }
  }
}
.group_1 {
  display: flex;
  .firstBox {
    cursor: pointer;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: 500;
    font-size: 18px;
    color: #482e11;
    padding: 14px 20px;
    width: 200px;
    height: 70px;
    background: #faf8f2;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #f6f0eb;
    margin-right: 24px;
    position: relative;
    .icon {
      position: absolute;
      right: 2px;
      bottom: 1px;
      img {
        width: 54px;
        height: 54px;
      }
    }
    .text_category {
      font-weight: 400;
      font-size: 12px;
      color: rgba(72, 46, 17, 0.7);
    }
  }
  .secondBox {
    cursor: pointer;
    padding: 14px 20px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: 500;
    font-size: 18px;
    color: #2a443c;
    width: 200px;
    height: 70px;
    background: #f0faf5;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #e7f0eb;
    margin-right: 24px;
    position: relative;
    .icon {
      position: absolute;
      right: 2px;
      bottom: 1px;
      img {
        width: 54px;
        height: 54px;
      }
    }
    .text_category {
      font-weight: 400;
      font-size: 12px;
      color: rgba(42, 68, 60, 0.7);
    }
  }
  .thirdBox {
    cursor: pointer;
    padding: 14px 20px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: 500;
    font-size: 18px;
    color: #242f62;
    width: 200px;
    height: 70px;
    background: #f5f6fd;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #e9effb;
    position: relative;
    .icon {
      position: absolute;
      right: 2px;
      bottom: 1px;
      img {
        width: 54px;
        height: 54px;
      }
    }
    .text_category {
      font-weight: 400;
      font-size: 12px;
      color: rgba(36, 47, 98, 0.7);
    }
  }
}
.codetitle {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: bold;
  font-size: 16px;
  color: #333;
}
.codeText {
  margin-top: 20px;
  width: 160px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #444444;
  margin-right: 25px;
  cursor: pointer;
  height: 25px;
  padding: 0 16px;
  line-height: 25px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  &:hover {
    background: rgba(64, 118, 246, 0.1);
    color: #217cbe;
    border-radius: 12px;
  }

  &.codeTextActive {
    background: rgba(64, 118, 246, 0.1);
    color: #217cbe;
    border-radius: 12px;
    font-weight: 500;
  }
}

.group_2,
.group_3,
.group_4 {
  margin-top: 24px;
}
.active23 {
  width: 200px;
  height: 70px;
  background: #faf8f2;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #d2b14c !important;
}
.active24 {
  width: 200px;
  height: 70px;
  background: #f0faf5;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #7bb598 !important;
}
.active25 {
  width: 200px;
  height: 70px;
  background: #f5f6fd;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px 8px 8px 8px;
  border: 1px solid #8193b3 !important;
}
.pagination-container {
  margin-top: 20px;
  text-align: center;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
